var map = {
	"./site-azul-royal (2).webp": 919,
	"./site-azul-royal (3).webp": 4194,
	"./site-azul-royal (4).webp": 8130,
	"./site-azul-royal (6).webp": 387,
	"./tela-azul-royal-site (11).webp": 808,
	"./tela-azul-royal-site (12).webp": 5846,
	"./tela-azul-royal-site (13).webp": 3202,
	"./tela-azul-royal-site (14).webp": 2067,
	"./tela-azul-royal-site (15).webp": 9213,
	"./tela-azul-royal-site (16).webp": 5663,
	"./tela-azul-royal-site (18).webp": 2512,
	"./tela-azul-royal-site (20).webp": 1739
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4495;